var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _ellipse, _ellipse2, _ellipse3, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _ellipse4, _path30, _path31, _path32, _ellipse5, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 311.03,
    x2: 332.41,
    y1: 208.3,
    y2: 188.56
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e75d48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502019"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 137.47,
    x2: 163.23,
    xlinkHref: "#a",
    y1: 235.44,
    y2: 211.66
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 44.8,
    x2: 68.37,
    xlinkHref: "#a",
    y1: 187.6,
    y2: 168.6
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 189.93,
    x2: 218.27,
    xlinkHref: "#a",
    y1: 210.01,
    y2: 172.22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m194.51 291.25-172.51-101.95c-5.49-3.08-10.2-8.15-4.85-11.46l173.14-99.78c2.6-1.61 6.54-2.66 9.18-1.13l181.07 105.07c5.49 3.19 6.48 12.1 1 15.29l-164.29 93.8a22.94 22.94 0 0 1 -22.74.16z",
    fill: "#e75d48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m322.29 182.6c-13.16 7.67-22.56 12.83-42.8 24.38 15.32 9.31 28.71 16.14 30.43 17.16l44-25c-3.57-1.83-15.25-8.44-31.63-16.54z",
    fill: "url(#a)",
    opacity: 0.32
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m151 204.47c-15.86 9.25-27.19 15.46-51.58 29.38 18.46 11.22 34.6 19.46 36.68 20.68l53-30.09c-4.25-2.24-18.32-10.21-38.1-19.97z",
    fill: "url(#b)",
    opacity: 0.32
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m54.27 193.95c8.23-5.48 16.6-10.76 24.92-16.09l-11.82-8.63-45.78 19.1c5.53 2.9 13 8.33 20.86 13.86 3.91-2.79 7.82-5.58 11.82-8.24z",
    fill: "url(#c)",
    opacity: 0.32
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m83.68 147.26a2.1 2.1 0 0 0 -.37-.78 4.67 4.67 0 0 0 -1.14-1c-5.81-3.93-13.86-5-20-1.17-1.4.88-3.49 2.87-2.66 4.75.48 1.09 1.94 1.73 3 2.17a44.57 44.57 0 0 0 10.49 2.77c1.3.22 2.62.44 3.93.56a5.43 5.43 0 0 0 4.79-2.05c.91-1.19 2.37-3.51 1.96-5.25z",
    fill: "#754c24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 148.2s5.3 4.8 14.46 4.1 9.87-5 9.87-5-2.37 30.36-3.62 30.88-5.93 2.78-8.19 2.95-9.4-2.69-9.58-3.48-2.94-29.45-2.94-29.45z",
    fill: "#ff8f6f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m61 104c-.28-.57-1.15-.07-.86.5 6.27 12.64 7.49 26.87 8.62 40.69.05.63 1.05.64 1 0-1.13-14.05-2.39-28.43-8.76-41.19z",
    fill: "#007f68"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m60.21 104.08s1.75 6.56-.06 9.84-3.3 3.93-1.14 8 7.94 4.62 8.32 7.74-2.76-20.01-7.12-25.58z",
    fill: "#007f68"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m80.26 115.92a82.45 82.45 0 0 0 -8 32.26c0 .78 1.19.77 1.22 0a81 81 0 0 1 7.79-31.66c.38-.69-.67-1.31-1.01-.6z",
    fill: "#007f68"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m81.12 119.11c0-.66-.15-2-.08-3.11l-.7.44c-2.38 5.79-5.94 19.39-7 23.55 1.45-3.12 7.38-3.55 9.12-8a8.19 8.19 0 0 0 .1-5.91 21.82 21.82 0 0 1 -1.44-6.97z",
    fill: "#007f68"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m214.59 232.12c16.12-8.68 54.27-27.87 70.27-36.75l-92.08-57.61-66.44 45.11c16.86 8.82 64.92 34.82 88.25 49.25z",
    fill: "url(#d)",
    opacity: 0.32
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m136.88 135c.07 21.33.19 40.53.19 40.53s.45 1.74 3.66.32v-42.13c-1.28.43-2.56.84-3.85 1.28z",
    fill: "#5b434d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m226.07 186.84c.07 21.33.19 40.53.19 40.53s.45 1.74 3.66.32v-42.09c-1.28.4-2.56.84-3.85 1.24z",
    fill: "#5b434d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m281 154.52c.07 21.33.19 40.53.19 40.53s.45 1.74 3.66.32v-42.09c-1.27.42-2.55.84-3.85 1.24z",
    fill: "#5b434d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m136.13 133.72v3.63l92.04 53.25 56.6-37.17.09-4.06",
    fill: "#a5dd73"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m136.13 133.72v3.63l92.04 53.25 56.6-37.17.09-4.06",
    fill: "#6db720",
    opacity: 0.76
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m136.13 133.72 59.22-33.78 89.51 49.43-57.01 37.59z",
    fill: "#a5dd73"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m218.31 116.14-12.47 6a2.87 2.87 0 0 0 -.2 5.07l29.57 17.25a2.87 2.87 0 0 0 3.86-.93l7.18-11.17",
    fill: "#56403d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m281 84.17-101.87-58.67a3.31 3.31 0 0 0 -5 2.87v62.33a2.56 2.56 0 0 0 1.28 2.21l108.39 62.57a1.23 1.23 0 0 0 1.85-1.07v-62.08a9.42 9.42 0 0 0 -4.65-8.16z",
    fill: "#68e1fd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m180.9 31 96.46 55.5a6.76 6.76 0 0 1 3.39 5.86v44.7a2.44 2.44 0 0 1 -3.66 2.12l-98.37-56.44a2.41 2.41 0 0 1 -1.21-2.09v-47.65a2.27 2.27 0 0 1 3.39-2z",
    fill: "#200a52"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.52,
    cy: 115.11,
    fill: "#ab643c",
    rx: 1.05,
    ry: 0.01,
    transform: "matrix(.98195871 -.18909544 .18909544 .98195871 -17.76 44.17)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.43,
    cy: 87.89,
    fill: "#659fe4",
    rx: 1.05,
    ry: 1.14
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.08,
    cy: 86.22,
    fill: "#c5e9ff",
    rx: 1.05,
    ry: 1.14
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m182.92 43.35 59.15 33.61",
    fill: "none",
    stroke: "#00a99d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m183.13 52.14 9.58 5.44",
    fill: "none",
    stroke: "#d4145a",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m195.54 59.42 53.24 29.27",
    fill: "none",
    stroke: "#29abe2",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m182.92 60.16 20.44 11.27",
    fill: "none",
    stroke: "#f7931e",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m206.75 73.57 44.83 23.98",
    fill: "none",
    stroke: "#00a99d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m316.58 80.64v43a4.79 4.79 0 0 1 -7.25 4.12l-40.91-24.4a4.79 4.79 0 0 1 -2.34-4.12v-42.24a4.79 4.79 0 0 1 7.19-4.15l40.91 23.62a4.79 4.79 0 0 1 2.4 4.17z",
    fill: "#a5dd73"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m287.38 75.78-13.26 9.75 11.89 16.69",
    fill: "none",
    stroke: "#006837",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m299.11 82.82 9.76 19.06-13.72 6.4",
    fill: "none",
    stroke: "#006837",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m183.77 122.22-21.49 12.28a1.48 1.48 0 0 0 0 2.56l59.72 34.33a4.77 4.77 0 0 0 4.76 0l20.11-11.61a1.54 1.54 0 0 0 0-2.67l-60.4-34.89a2.67 2.67 0 0 0 -2.7 0z",
    fill: "#200a52"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m216.24 141.8-6.13 3.64 4.55 2.64 6.16-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.52 137.89-6.13 3.64 5.77 3.35 6.16-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.1 123.71-6.23 3.58 5.54 3.22 6.16-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.23 131.34-6.13 3.66 4.55 2.64 6.16-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.51 127.43-6.13 3.64 5.76 3.35c.68-.39 4.54-2.67 6.16-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.75 145-6.13 3.64 4.36 2.53 6.15-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.74 134.54-6.13 3.64 4.82 2.8 6.16-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.07 148.08-6.13 3.64 5.77 3.35 6.16-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.79 151.99-6.14 3.63 10.35 6.01 6.23-3.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.08 128.35-6.23 3.58 8.06 4.68 6.16-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.72 137.43-6.13 3.64 4.55 2.64 6.16-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205 144-6.13 3.64 5.77 3.35 6.16-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.23 140.63-6.13 3.64 4.82 2.8 6.16-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.73 147.89-6.13 3.64 4.55 2.64 6.15-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.24 151.09-6.13 3.64 4.36 2.53 6.15-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187 133.53-6.13 3.64 5.76 3.35 6.16-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.55 154.18-6.13 3.64 5.77 3.35 6.15-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.14 161.72 7.83 4.55 6.24-3.58-7.94-4.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.55 161.09-4.56 2.72 5.29 3.06 4.63-2.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.38 167.51 4.5 2.6 4.64-2.65-4.59-2.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.39 133.12-4.78 2.66 5.42 3.13 4.69-2.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.73 136.81-4.61 2.74 5.79 3.35 4.68-2.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.61 140.8-4.6 2.74 33.88 19.63 4.64-2.67z"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 339.69,
    cy: 192.74,
    fill: "#68e1fd",
    rx: 18.83,
    ry: 9.31
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m358.53 167.94v25.32s-14 13-37.67.21v-25.53",
    fill: "#68e1fd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m343.83 192.49c-5.2 4-11.48 5.9-17.92 6.58a30.14 30.14 0 0 0 13.78 3c10 0 18.17-3.86 18.77-8.74l.06-.05v-25.34h-.35c-3.17 9.06-6.51 18.47-14.34 24.55z",
    fill: "#200a52",
    opacity: 0.21
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m323.68 177s-3.12-4.77-6.06-2-.37 12.3 8.26 13.22v3.78s-10.83-1.47-12.3-11.2 5.51-11.23 9-8.55",
    fill: "#68e1fd"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 339.69,
    cy: 168.04,
    fill: "#663535",
    rx: 18.83,
    ry: 9.31
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m162.47 168c-4.64-3.24-10.1-5-16-3.72-6.28 1.38-11.72 5.33-18.12 6.3-1 .15-5.05-.11-5.67.48-17.81 16.86 32 15.05 32 15.05 4.83-4 9.38-7.85 14.18-11.85-1.46-3.2-3.86-4.48-6.39-6.26z",
    fill: "#f8997c"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m139 192.48-1.77 50.86c-.07 1.93 2.93 1.93 3 0l1.77-50.86c.1-1.93-2.89-1.92-3 0z",
    fill: "#f8997c"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m176.37 219.69q-13.6-13.31-26-27.78c-1.26-1.47-3.37.66-2.12 2.12q12.38 14.46 26 27.78c1.38 1.35 3.51-.81 2.12-2.12z",
    fill: "#f8997c"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m128.64 187.78q-10.56 19.93-19.89 40.47c-.79 1.74 1.79 3.27 2.59 1.51q9.33-20.54 19.89-40.47c.9-1.7-1.68-3.22-2.59-1.51z",
    fill: "#f8997c"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m163.71 134c.61-.15 5.74-1.47 7-1.89s5.16-3.45 7.28-3 6.39 3.26 6.59 4.2-1 2.08-1.45 2.49-3.54-.72-4.74-.91-3.11 2.65-4.24 3.15-8.43 1.81-8.43 1.81",
    fill: "#fcbf81"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m177.5 146.46c.61-.15 5.74-1.47 7-1.89s5.16-3.45 7.28-3 6.39 3.26 6.59 4.2-1 2.08-1.45 2.49-3.54-.72-4.74-.91-3.11 2.65-4.24 3.15-8.43 1.81-8.43 1.81",
    fill: "#fcbf81"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m175.51 211.09c.93-1 1.54-2 1.22-3.05-.57-1.87-3.11-2.63-4.85-2.53s-3.54 1-5.3 1.5a13.17 13.17 0 0 1 -5.75.71 1.28 1.28 0 0 1 -.8-.45 3.17 3.17 0 0 1 -2.33-2.12l-5.76-2.06s-1.47 12.17-1.42 13c.43 6.57 10.24 2.82 10.24 2.82s.35-3 .44-3.37 3.85.77 5.4.53a6.8 6.8 0 0 0 2-.93c1.16-.64 2.3-1.32 3.43-2s2.31-1.35 3.48-2.05z",
    fill: "#56403d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m154 166.17c-2.16.21-4.32.49-6.47.8q1.34 20.73 3 41.43c5.6 2.29 7.87 1.23 11.34-2.32.66-13.17 1.81-27 1.78-40.28-3.2.14-6.42.28-9.65.37z",
    fill: "#34323d"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m130.73 162.38s-.93 15.13 6.67 18.5 23.19 1.69 30.86-2.81a82.82 82.82 0 0 1 12.44-6.21s2-6.62-2.81-9.48-15.35-6.4-24.73 0",
    fill: "#34323d"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m169.48 139.73c.81-3.09.34-8.19.34-8.19s-9.49 1.62-13.49 1-10.54-9-10.54-9l.89 16.6c7.58 1.59 15.43 1.93 22.8-.41z",
    fill: "#ba3e00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m193.06 220.57c.93-1 1.54-2 1.22-3.05-.57-1.87-3.11-2.63-4.85-2.53s-3.54 1-5.3 1.5a13.17 13.17 0 0 1 -5.75.71 1.28 1.28 0 0 1 -.8-.45 3.17 3.17 0 0 1 -2.33-2.12l-5.76-2.06s-1.47 12.17-1.42 13c.43 6.57 10.24 2.82 10.24 2.82s.35-3 .44-3.37 3.85.77 5.4.53a6.8 6.8 0 0 0 2-.93c1.16-.64 2.3-1.32 3.43-2s2.32-1.35 3.48-2.05z",
    fill: "#56403d"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m170.9 162.75c-2-.94-4.06-.84-6.44-.83.33 4.87.15 6.62.45 11.48l.08 1.29c.92 14.4 2 28.79 3.1 43.18 5.6 2.29 7.87 1.23 11.34-2.32.77-15.33 2.22-31.51 1.66-46.77-3.23-3.2-6.09-4.11-10.19-6.03z",
    fill: "#34323d"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m130.6 159.25c0 .37.07 1.62.13 3.13 3.15 4.15 7 6.58 13 6.4 4.89-.14 9-2.28 12.8-4.92-.48-8.85-1.91-24-4.14-34.53-.19-.89-2.5-1.49-3.18-1.86-1.59-.87-.66-2.37-2.22-3.3a53.5 53.5 0 0 0 -7.05-3.44h-.06c-3.89-.06-10.6 2.94-11 8.15-.61 8 .27 12.85.89 20.84.23 3.22.56 6.4.83 9.53z",
    fill: "#e55600"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m144.15 105.56c.51.13 4.83 10.07 3.14 16.11s-11.95-.17-14.53-4.77 1.69-13.9 11.39-11.34z",
    fill: "#fcbf81"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m144 106.95s0 3.28-2.87 4.34-5.26 1.77-5.1 3.1 5.19-.19 5.21 2.85a22.66 22.66 0 0 1 -.82 6.06c-.32 1.49-8.93-3.08-11.77-10.86s4.27-9.85 4.62-9.9 1-2.17 4.47-2.93 4.47.6 4.47.6a4.23 4.23 0 0 1 5.09.55c3.21 2.55 2.4 7.21-1.24 9.1z",
    fill: "#34323d"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m183.6 144c-4.47.93-13.55 2.41-16.76 1-2.49-1.09-10.8-18.91-19.83-20.82l-1.22 13.6s12.77 16.2 18.67 17.87c4.29 1.21 15.84-.41 20.91-2.17a19.35 19.35 0 0 0 -1.77-9.48z",
    fill: "#e55600"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m155.31 148.19c-.65-.84-8.05-9.22-8.05-9.22l8.89 18.21z",
    fill: "#34323d"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m168.16 174a22.48 22.48 0 0 1 -11.24 8.25c-6.34 1.93-15.56 1-18.89-5.61-6.06-12.06-.37-27.16-6.77-38.89a11.76 11.76 0 0 0 -7.43-6.1c-4.15-.91-7 2.21-8.5 5.88-2.7 6.58-2.6 14.77-2.47 21.78a118.92 118.92 0 0 0 1.23 16.92s3.88 23.51 34.12 17.2a45.47 45.47 0 0 0 14.86-5.5 20.48 20.48 0 0 0 6.06-5.33c1.87-2.72.62-5.91-.97-8.6z",
    fill: "#68e1fd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.09e2f1c083c989faf29030d605c5706a.svg";
export { ForwardRef as ReactComponent };